// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import BillingTypologyController from "./billing_typology_controller"
application.register("billing-typology", BillingTypologyController)

import IntervalToggleController from "./interval_toggle_controller"
application.register("interval-toggle", IntervalToggleController)

import InvoiceLinesController from "./invoice_lines_controller"
application.register("invoice-lines", InvoiceLinesController)
